import { Col, Form, Input, Row } from 'antd';

import AddressUnitsSelector from '../../components/common/AddressUnitSelector';
import {
  BRANCH_NAME_MAX_LENGTH,
  PHONE_NUMBER_LENGTH,
  branchNameRules,
  phoneNumberRules,
} from '../../utils/formRules';
import BranchLocationPicker from './BranchLocationPicker';
import './profilepage.less';

const { TextArea } = Input;

/** Хаягийн сонголтууд мөрөндөө ижил зайтай байхын тулд */
const addressStyleProps = { rowGutter: [16, 0] };

const EditBranchForm = ({ addressArray, setAddressArray, form, setPosition, rowId }) => {
  return (
    <Form layout="vertical" form={form}>
      <Row gutter={[16, 0]}>
        <Col xs={24} md={8} xl={6}>
          <Form.Item name="name" label="Салбарын нэр" rules={branchNameRules()}>
            <Input size="large" placeholder="Энд бич" maxLength={BRANCH_NAME_MAX_LENGTH} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8} xl={6}>
          <Form.Item
            name="phoneNumber"
            label="Салбарын утас"
            rules={phoneNumberRules('Салбарын утас дутуу байна.')}
          >
            <Input size="large" placeholder="Энд бич" maxLength={PHONE_NUMBER_LENGTH} />
          </Form.Item>
        </Col>
      </Row>

      <AddressUnitsSelector
        selectedUnits={addressArray}
        onChange={setAddressArray}
        form={form}
        styleProps={addressStyleProps}
      />

      <Row gutter={[16, 0]}>
        <Col xs={24} xl={18}>
          <Form.Item
            name="addressDetail"
            label="Дэлгэрэнгүй хаяг"
            rules={[{ required: true, message: 'Дэлгэрэнгүй хаяг дутуу байна.' }]}
          >
            <TextArea rows={4} placeholder="Энд бич" />
          </Form.Item>
        </Col>
      </Row>

      <BranchLocationPicker form={form} setPosition={setPosition} resetKey={rowId} />

    </Form>
  );
};

export default EditBranchForm;
